import { SharePool, ISharePool } from 'Core/Api/Api';
import { random } from 'lodash';

export default class GiftRecipientFormModel {
    isNew?: boolean;
    key?: number;
    jcsdNumber?: string | undefined;
    name?: string | undefined;
    numberOfShares?: number;


    constructor(isNew?: boolean, name?: string, jcsdNumber?: string, numberOfShares?: number) {
        this.name = name;
        this.jcsdNumber = jcsdNumber;
        this.numberOfShares = numberOfShares;
        this.isNew = isNew;
        this.key = random(10, 999999);
    }
}
